export const BASIC_COURSES_BEGIN = 'basic_courses_begin';
export const BASIC_COURSES_SUCCESS = 'basic_courses_success';
export const BASIC_COURSES_ERROR = 'basic_courses_error';

export const EDUCATION_COURSES_BEGIN = 'education_courses_begin';
export const EDUCATION_COURSES_SUCCESS = 'education_courses_success';
export const EDUCATION_COURSES_ERROR = 'education_courses_error';

export const BLOG_BEGIN = 'blog_begin';
export const BLOG_SUCCESS = 'blog_success';
export const BLOG_ERROR = 'blog_error';

export const NEWSLETTER_BEGIN = 'newsletter_begin';
export const NEWSLETTER_SUCCESS = 'newsletter_success';
export const NEWSLETTER_ERROR = 'newsletter_error';
export const NEWSLETTER_RESET = 'newsletter_reset';

// START:  Define Constants For Theme Customization of News Event Sections
export const GET_NEWS_EVENTS_BEGIN = 'get_news_events_begin';
export const GET_NEWS_EVENTS_REQUESTING = 'get_news_events_requesting';
export const GET_NEWS_EVENTS_SUCCESS = 'get_news_events_success';
export const GET_NEWS_EVENTS_ERROR = 'get_news_events_error';
export const GET_NEWS_EVENTS_RESET = 'get_news_events_reset';

// END:  Define Constants For Theme Customization of News Event Sections
